<template>
    <div class="loading">
        <img src="@/assets/images/loading/loading_bg.png" alt="" class="w-100 loading__bg">
        <img src="@/assets/images/loading/loading_train.png" alt="" class="position-absolute loading__train">
    </div>
</template>